import React, { useLayoutEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const OPTIONS = [
  { value: "monthly", label: "Mensal" },
  { value: "annual", label: "Anual", discount: "-20%" },
];

export default function BillingToggle({ value, onChange }) {
  const containerRef = useRef(null);
  const optionRefs = useRef({});
  const [indicator, setIndicator] = useState({ x: 0, width: 0 });

  useLayoutEffect(() => {
    const el = optionRefs.current[value];
    const wrap = containerRef.current;
    if (!el || !wrap) return;
    const wrapRect = wrap.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    setIndicator({ x: elRect.left - wrapRect.left, width: elRect.width });
  }, [value]);

  return (
    <div className="billing-toggle-wrap">
      <div
        className="billing-toggle"
        role="tablist"
        ref={containerRef}
        data-testid="billing-toggle"
      >
        <motion.span
          className="billing-toggle-bg"
          aria-hidden="true"
          initial={false}
          animate={{ x: indicator.x, width: indicator.width }}
          transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
          style={{ left: 0 }}
        />
        {OPTIONS.map((opt) => {
          const active = value === opt.value;
          return (
            <button
              key={opt.value}
              ref={(node) => {
                if (node) optionRefs.current[opt.value] = node;
              }}
              role="tab"
              aria-selected={active}
              className={`billing-toggle-option ${active ? "billing-toggle-option-active" : ""}`}
              onClick={() => onChange(opt.value)}
              data-testid={`billing-toggle-${opt.value}`}
            >
              {opt.label}
              {opt.discount && (
                <span className="billing-toggle-discount">{opt.discount}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
